import Axios from "axios";
import Vue from "vue";
import VueLocalStorage from "vue-localstorage";

Vue.use(VueLocalStorage);

let instance = null;

const BASE_URL =
  process.env.VUE_APP_BASE_URL || "http://apibluebox.komarcalabs.com/api/v1/";

const HTTP = Axios.create({
  baseURL: BASE_URL,
  headers: {
    "X-Access-Token": `${Vue.localStorage.get("accessToken")}`,
  },
});

class Service {
  constructor() {
    if (!instance) instance = this;
    return instance;
  }

  login(payload) {
    return HTTP.post("/users/login", payload).then((response) => response);
  }

  recoverPassword(payload) {
    console.log({payload});
    return HTTP.post("/users/forgetpass", payload).then((response) => response);
  }

  getUserByID(payload) {
    return HTTP.get(`/users/${payload}`).then((response) => response);
  }

  updateHeaders(token) {
    Axios.defaults.headers.common["X-Access-Token"] = `${token}`;
    HTTP.defaults.headers = Axios.defaults.headers;
    Vue.localStorage.set("accessToken", token);
  }

  //obtener empleados
  getEmployees(payload) {
    let query = payload.search ? `&search=${payload.search}` : ""
    return HTTP.get(
      `business/${payload.id}/employees?page=${payload.page}&state=${payload.state}${query}`
    )
      .then((res) => res)
      .catch((err) => err.response);
  }

  //obtener reportes diarios de los empleados
  getEmployeesDailyReport(payload) {
    return HTTP.get(
      `business/${payload.businessID}/dayreports?date=${payload.date}`
    ).then((res) => res);
  }

  //obtner reporte anual por empleado
  getEmployeeReport(payload) {
    return HTTP.get(
      `employee/${payload.id}/dayreports?year=${payload.year}&month=${
        payload.month
      }`
    ).then((res) => res);
  }
  updateEmployee(payload) {
    return HTTP.patch(`employee/${payload.id}`, payload.body)
      .then((res) => res)
      .catch((err) => err.response);
  }

  //actualiza reporte diario
  updateDailyReport(payload) {
    return HTTP.put(`employee/${payload.employee}/dayreports`, payload).then(
      (res) => res
    );
  }

  setTRegister(payload) {
    return HTTP.post(`business/${payload.businessId}/tregister`, payload.data)
      .then((res) => res)
      .catch((err) => err.response);
  }

  getRUCdata(payload) {
    return HTTP.get(`/findByRuc?ruc=${payload}`)
      .then((res) => res)
      .catch((err) => err.response);
  }

  getBusiness(payload) {
    return HTTP.get(`/business?page=${payload}`)
      .then((res) => res)
      .catch((err) => err.response);
  }
  getBusinessAux({ page, limit }) {
    return HTTP.get(`/business?page=${page}&limit=${limit}`)
      .then((res) => res)
      .catch((err) => err.response);
  }

  postBusiness(payload) {
    return HTTP.post(`/business`, payload)
      .then((res) => res)
      .catch((err) => err.response);
  }
  getBusinessById(payload) {
    return HTTP.get(`/business/${payload}`)
      .then((res) => res)
      .catch((err) => err.response);
  }
  putBusiness(payload) {
    return HTTP.put(`/business/${payload.id}`, payload.body).then((res) => res);
  }

  deleteBusiness(payload) {
    return HTTP.delete(`/business/${payload}`)
      .then((res) => res)
      .catch((err) => err.response);
  }

  //Detalle de la empresa
  getDetailBusiness(payload) {
    return HTTP.get(`business/${payload}`).then((res) => res);
  }

  //listado de conceptos de pago
  getItdConcepts() {
    return HTTP.get(`itdconcepts`).then((res) => res);
  }

  //Conceptos de pago para cada trabajador
  getEmployeeConcepts(payload) {
    return HTTP.get(`/employee/${payload}/concepts`)
      .then((res) => res)
      .catch((err) => err.response);
  }
  addEmployeeConcepts(payload) {
    return HTTP.post(`/employee/${payload.id}/concepts`, payload.body)
      .then((res) => res)
      .catch((err) => err.response);
  }
  updateEmployeeConcepts(payload) {
    return HTTP.put(
      `/employee/${payload.id}/concepts/${payload.fk}`,
      payload.body
    )
      .then((res) => res)
      .catch((err) => err.response);
  }
  downEmployeeConcepts({id, fk, body}) {
    return HTTP.put(
      `/employee/${id}/concepts/${fk}/getdown`,
      body
    )
      .then((res) => res)
      .catch((err) => err.response);
  }
  deleteEmployeeConcepts(payload) {
    return HTTP.delete(`/employee/${payload.id}/concepts/${payload.fk}`)
      .then((res) => res)
      .catch((err) => err.response);
  }
  getVariablesConcepts({id, page}) {
    return HTTP.get(`/employee/${id}/variableconcepts/?page=${page}`)
      .then((res) => res)
      .catch((err) => err.response);
  }
  getHistoricConcepts(payload) {
    console.log(payload);
    return HTTP.get(`/employee/${payload.id}/historic/`, {params: payload.params})
      .then((res) => res)
      .catch((err) => err.response);
  }
  setVacationVariables({id, body}){
    return HTTP.put(`/employee/${id}/vacationhistoric`,body).then(res => res).catch(err => err.response)
  }
  getEmployeeCts({id, query}){
    return HTTP.get(`/employee/${id}/cts?${query}`).then(res => res).catch(err => err.response);
  }
  getEmployeeCtsReal({id, query}){
    return HTTP.get(`/employee/${id}/cts-real?${query}`).then(res => res).catch(err => err.response);
  }
  setEmployeeCtsReal({id, body}){
    return HTTP.put(`/employee/${id}/cts-real`,body).then(res => res).catch(err => err.response);
  }
  getEmployeeGratiReal({id, query}){
    return HTTP.get(`/employee/${id}/gratification-real?${query}`).then(res => res).catch(err => err.response);
  }
  setEmployeeGratiReal({id, body}){
    return HTTP.put(`/employee/${id}/gratification-real`,body).then(res => res).catch(err => err.response);
  }

  //TRegisters
  createTRegister(payload) {
    return HTTP.post(
      `business/${payload.businessId}/tregister`,
      payload.data
    ).then((res) => res);
  }

  // getTRegisters(payload) {
  //   return HTTP.get(`business/${payload}/tregister`).then(res => res);
  // }

  getTRegisters(payload) {
    if (payload.state == "pendxcomp") {
      return HTTP.get(
        `business/${payload.id}/tregister?state=pending&state=complete&page=${
          payload.page
        }`
      ).then((res) => res);
    } else if (payload.search) {
      return HTTP.get(
        `business/${payload.id}/tregister?state=${payload.state}&page=${
          payload.page
        }&search=${payload.search}`
      ).then((res) => res);
    } else {
      return HTTP.get(
        `business/${payload.id}/tregister?state=${payload.state}&page=${
          payload.page
        }`
      ).then((res) => res);
    }
  }

  updateTRegister(payload) {
    return HTTP.put(`tregister/${payload.tregisterId}`, payload.data).then(
      (res) => res
    );
  }

  deleteTRegister(payload) {
    return HTTP.delete(`tregister/${payload}`).then((res) => res);
  }

  getTRegister(payload) {
    return HTTP.get(`tregister/${payload}`).then((res) => res);
  }

  //derechohabientes
  updateRightholder(payload) {
    return HTTP.put(`rightholders/${payload.id}`, payload).then((res) => res);
  }

  createRightholder(payload) {
    return HTTP.post(`tregister/${payload.id}/rightholders`, payload.data).then(
      (res) => res
    );
  }

  //Commisions
  postCommissions(payload) {
    return HTTP.post(
      `/employee/${payload.id}/comm-bonus-discount`,
      payload.body
    )
      .then((res) => res)
      .catch((err) => err.response);
  }

  //detalle del empleado
  getCommissionList(payload) {
    return HTTP.get(`employee/${payload}/`)
      .then((res) => res)
      .catch((err) => err.response);
  }

  deleteCommission(payload) {
    return HTTP.delete(`commisions/${payload}`).then((res) => res);
  }

  getDeductionList({id, page}) {
    return HTTP.get(`employee/${id}/deductions?page=${page}`)
      .then((res) => res)
      .catch((err) => err.response);
  }

  //conceptos d pago
  addConcept(payload) {
    return HTTP.put(`business/${payload.id}/linkconcept`, payload.body).then(
      (res) => res
    );
  }

  unlinkConcept(payload) {
    return HTTP.put(`business/${payload.id}/unlinkconcept`, payload.body).then(
      (res) => res
    );
  }

  getSystemUsers() {
    return HTTP.get(`users/`)
      .then((res) => res)
      .catch((err) => err.response);
  }
  postSystemUsers(payload) {
    return HTTP.post(`/users/`, payload)
      .then((res) => res)
      .catch((err) => err.response);
  }
  updateSystemUsersInfo(payload) {
    return HTTP.put(`/users/${payload.id}/`, payload.body)
      .then((res) => res)
      .catch((err) => err.response);
  }
  linkSystemUsersBusiness(payload) {
    return HTTP.put(`/users/${payload.id}/linkbusiness/${payload.fk}`, payload.body)
      .then((res) => res)
      .catch((err) => err.response);
  }
  unlinkSystemUsersBusiness(payload) {
    return HTTP.put(`/users/${payload.id}/unlinkbusiness/${payload.fk}`)
      .then((res) => res)
      .catch((err) => err.response);
  }

  //obtieniendo los empleos

  getOccupations(payload) {
    return HTTP.get(`occupations?search=${payload}`).then((res) => res);
  }

  //Calculos
  getSummaryByMonth(payload) {
    return HTTP.get(
      `/business/${payload.id}/summaries/bymont?date=${payload.date}`
    )
      .then((res) => res)
      .catch((err) => err.response);
  }
  getSummaryByYear(payload) {
    return HTTP.get(`/business/${payload}/summaries/byyear`)
      .then((res) => res)
      .catch((err) => err.response);
  }
  getCalcByMonth(payload) {
    return HTTP.get(
      `/business/${payload.id}/summaries/bymontdetail?employee=${
        payload.employee
      }&date=${payload.date}`
    )
      .then((res) => res)
      .catch((err) => err.response);
  }
  getCtsData({id, date}) {
    return HTTP.get(`/business/${id}/summaries/cts?date=${date}`).then(res => res).catch(err => err.response);
  }

  //generar Empleado con tregistro
  createEmployee(payload) {
    // console.log(payload)
    return HTTP.put(
      `business/${payload.id}/tregister/convertToEmployee`,
      payload.body
    ).then((r) => r);
  }

  downTR(payload) {
    return HTTP.put(`tregister/${payload.id}/getdown`, payload.body).then(
      (r) => r
    );
  }
  getDashboard(payload) {
    return HTTP.get(`business/${payload}/dashboard/resume`)
      .then((res) => res)
      .catch((err) => err.response);
  }

  //subir contrato
  uploadContract(payload) {
    var fdata = new FormData();
    fdata.append("file_upload", payload.file);
    return HTTP.post(`/employee/${payload.id}/contract`, fdata)
      .then((res) => res)
      .catch((err) => err.response);
  }
  cargaMasiva(payload) {
    var fdata = new FormData();
    fdata.append("file_upload", payload.file);
    return HTTP.post(`/business/${payload.id}/tregister/massiveupload`, fdata)
      .then((res) => res)
      .catch((err) => err.response);
  }
  uploadRightHolders(payload) {
    var fdata = new FormData();
    fdata.append("file_upload", payload.file);
    return HTTP.post(
      `/business/${payload.id}/tregister/uploadrightholders`,
      fdata
    )
      .then((res) => res)
      .catch((err) => err.response);
  }
  uploadHistoric(payload) {
    var fdata = new FormData();
    fdata.append("file_upload", payload.file);
    return HTTP.post(`/business/${payload.id}/tregister/uploadhistoric`, fdata)
      .then((res) => res)
      .catch((err) => err.response);
  }

  /**
   * VARIANTS
   */
  runEmployee(payload) {
    return HTTP.put(`/variants/runEmployee?employeeId=${payload}`)
      .then((res) => res)
      .catch((err) => err.response);
  }
  clearEmployee(payload) {
    return HTTP.put(`/variants/clearEmployee?employeeId=${payload}`)
      .then((res) => res)
      .catch((err) => err.response);
  }
  // validateMonth({id, date}) {
  //   return HTTP.put(`/variants/validateMonth?employeeId=${id}&date=${date}`)
  //     .then((res) => res)
  //     .catch((err) => err.response);
  // }
  updateVariant({id, body}){
    return HTTP.put(`variants/${id}`,body).then(res => res).catch(err => err.response);
  }
  recalculate({id}){
    return HTTP.put(`/business/${id}/recalculate`)
  }
  /**
   * REPORTES
   */
  downloadXls({id,date}){
    return HTTP.post(`/business/${id}/summaries/downloadxls?date=${date}`).then(res =>res).catch(err => err.response);
  }
  downloadPdf({id,body}){
    return HTTP.post(`/business/${id}/summaries/downloadpdf`,body).then(res =>res).catch(err => err.response);
  }

  updateCts({id, body}){
    return HTTP.put(`/employee/${id}/prev-cts`, body).then(res => res).catch(err => err.response);
  }

  /**
   * TREGISTROS HISTORICO
   */
  createTregistroHistorico({id, body}){
    return HTTP.post(`/tregister/${id}/historic/`, body).then(res => res).catch(err => err.response);
  }
  getTregistroHistorico({id, query}){
    return HTTP.get(`/tregister/${id}/historic/?${query}`).then(res => res).catch(err => err.response)
  }
  getTregistroHistoricoDetail({id,fk}){
    return HTTP.get(`/tregister/${id}/historic/${fk}`).then(res => res).catch(err => err.response)
  }
  updateTregistroHistorico({id, fk, body}){
    return HTTP.put(`/tregister/${id}/historic/${fk}`, body).then(res => res).catch(err => err.response)
  }
  deleteTregistroHistorico({id, fk}){
    return HTTP.delete(`/tregister/${id}/historic/${fk}`).then(res => res).catch(err => err.response)
  }

  /**
   * VACACIONES
   */
  getVacations({id, startDate, endDate}){
    let startDateQuery="";
    if(startDate) startDateQuery = `&startDate=${startDate}`
    return HTTP.get(`/business/${id}/summaries/vacations?endDate=${endDate}${startDateQuery}`).then(res => res).catch(err => err.response)
  }
  getVacationVariable({id}){
    console.log("getVacationVariable", id);
    return HTTP.get(`/employee/${id}/vacationhistoric`).then(res => res).catch(err => err.response)
  }

  /**
   * LIQUIDACIONES
   */
  getDownData({id, date}){
    if(!date) return HTTP.get(`/tregister/${id}/getdown`).then(res => res).catch(err => err.response);
    return HTTP.get(`/tregister/${id}/getdown?date=${date}`).then(res => res).catch(err => err.response);
  }

  /**
   * Vacaciones por empleado
   */
  createVacationHistoric({id, body}){
    return HTTP.post(`/employee/${id}/vacationhistoric`, body);
  }
  getVacationHistoric(id){
    console.log("getVacationHistoric", id);
    return HTTP.get(`/employee/${id}/vacationhistoric`);
  }
  updateVacationHistoric({id, body}){
    return HTTP.put(`/employee/${id}/vacationhistoric`, body);
  }

  /**
   * Validacion de Mes
   */
  validateMonth({id,date}){
    return HTTP.put(`/employee/${id}/validate?date=${date}`);
  }

  /**
   * HISTORICO DE EMPRESAS
   */
  createBusinessHistoric({id,body}){
    return HTTP.post(`/business/${id}/historic/`,body).then(res => res).catch(err => err.response);
  }
  getBusinessHistory({id, query}){
    return HTTP.get(`/business/${id}/historic/?${query}`).then(res => res).catch(err => err.response)
  }
  getBusinessHistoricDetail({id,fk}){
    return HTTP.get(`/business/${id}/historic/${fk}`).then(res => res).catch(err => err.response)
  }
  updateBusinessHistoric({id,fk, body}){
    return HTTP.put(`/business/${id}/historic/${fk}`,body).then(res => res).catch(err => err.response)
  }
  deleteBusinessHistoric({id,fk}){
    return HTTP.delete(`/business/${id}/historic/${fk}`).then(res => res).catch(err => err.response)
  }

  //PLAME
  getBusinessPlame({id, date}) {
    return HTTP.get(`/business/${id}/plame/?date=${date}`).then(res => res).catch(err => err.response)
  }

  updateTardiness({id, body}) {
    return HTTP.put(`/business/${id}/dayreports-tardiness`, body).then(res => res).catch(err => err.response)
  }

  getFactors({id, expiredAt, depositAt}){

    return HTTP.get(`/employee/${id}/factor-calc?date=${expiredAt}&depositAt=${depositAt}`).then(res => res).catch(err => err.response)
  }
}

export const service = new Service();
